import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, Timer, ShoppingCart, Ticket } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(10 * 60);
  const [showUrgency, setShowUrgency] = useState(false);
  const [isCyclingVisible, setIsCyclingVisible] = useState(true);
  const [showPurchase, setShowPurchase] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        const rect = pricingSection.getBoundingClientRect();
        // Show urgency when the pricing section is near the top of the viewport
        const isVisible = rect.top < 400;
        setShowUrgency(isVisible);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Visibility cycle: disappears after a while and reappears after ~2 minutes
  useEffect(() => {
    if (!showUrgency) {
      setIsCyclingVisible(true);
      return;
    }
    let timer: NodeJS.Timeout;
    if (isCyclingVisible) {
      // Hide after 15 seconds of being visible
      timer = setTimeout(() => {
        setIsCyclingVisible(false);
      }, 15000);
    } else {
      // Reappear after 2 minutes (120,000 ms)
      timer = setTimeout(() => {
        setIsCyclingVisible(true);
      }, 120000);
    }
    return () => clearTimeout(timer);
  }, [showUrgency, isCyclingVisible]);
  useEffect(() => {
    if (showUrgency && isCyclingVisible) {
      const timer = setTimeout(() => {
        setShowPurchase(true);
      }, 3000);
      return () => clearTimeout(timer);
    } else {
      setShowPurchase(false);
    }
  }, [showUrgency, isCyclingVisible]);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <>
      {/* Initial Social Proof - Not Fixed */}
      {!showUrgency && <div className="w-full py-2 px-4 bg-transparent" data-id="element-78">
          <div className="max-w-5xl mx-auto flex md:gap-12 text-[12px] md:text-sm font-black uppercase tracking-widest w-fit drop-shadow-[0_2px_4px_rgba(0,0,0,1)] text-white flex-row items-center justify-center gap-[0px]" data-id="element-79">
            <div className="flex items-center gap-2" data-id="element-80">
              <span className="text-yellow-400 text-xl drop-shadow-[0_0_8px_rgba(250,204,21,0.5)]" data-id="element-81">
                ★
              </span>
              <span className="drop-shadow-[0_0_10px_rgba(255,255,255,0.3)] font-[900] font-sans text-[#131212]" data-id="element-82">
                +1.500 ALUMNOS
              </span>
            </div>
            <div className="w-px h-5 bg-white/30 hidden md:block" data-id="element-83" />
            <div className="flex items-center gap-2" data-id="element-84">
              <span className="text-yellow-400 text-xl drop-shadow-[0_0_8px_rgba(250,204,21,0.5)]" data-id="element-85">
                🕒
              </span>
              <span className="drop-shadow-[0_0_10px_rgba(255,255,255,0.3)] text-[#0F0E0E]" data-id="element-86">
                ACCESO INMEDIATO
              </span>
            </div>
            <div className="w-px h-5 bg-white/30 hidden md:block" data-id="element-87" />
            <div className="flex items-center gap-2" data-id="element-88">
              <span className="text-yellow-400 text-xl drop-shadow-[0_0_8px_rgba(250,204,21,0.5)]" data-id="element-89">
                🛡️
              </span>
              <span className="drop-shadow-[0_0_10px_rgba(255,255,255,0.3)] text-[#0F0D0D]" data-id="element-90">
                GARANTÍA 7 DÍAS
              </span>
            </div>
          </div>
        </div>}

      {/* Fixed Urgency Panel */}
      <AnimatePresence data-id="element-91">
        {showUrgency && isCyclingVisible && <div className="fixed top-4 left-0 right-0 z-50 px-4 pointer-events-none" data-id="element-92">
            <div className="max-w-md mx-auto flex flex-col items-center gap-3 pointer-events-auto" data-id="element-93">
              <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} className="bg-white/95 backdrop-blur-md py-4 px-10 rounded-[3rem] shadow-2xl border border-blue-100 flex flex-col min-w-[300px] pt-[0px] pb-[0px] pl-[20px] pr-[20px] gap-[0px]" data-id="element-94">
                <div className="flex items-center justify-start gap-4" data-id="element-95">
                  <div className="w-4 h-4 rounded-full bg-green-500 animate-pulse shadow-[0_0_10px_rgba(34,197,94,0.5)]" data-id="element-96" />
                  <Users className="w-5 h-5 text-[#4c1d95]" data-id="element-97" />
                  <span className="text-[#4c1d95] font-black text-base tracking-tight" data-id="element-98">
                    27 PERSONAS MIRANDO
                  </span>
                </div>
                <div className="flex gap-4 items-center justify-start" data-id="element-99">
                  <div className="w-4 h-4 rounded-full bg-red-500 shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-100" />
                  <Ticket className="w-5 h-5 text-[#4c1d95]" data-id="element-101" />
                  <span className="text-[#4c1d95] font-black text-base tracking-tight uppercase" data-id="element-102">
                    CUPOS DISPONIBLES: 7
                  </span>
                </div>
              </motion.div>

              <AnimatePresence data-id="element-103">
                {showPurchase && <motion.div initial={{
              opacity: 0,
              scale: 0.9,
              y: 10
            }} animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }} className="bg-green-600 text-white py-3 px-8 rounded-full shadow-xl flex items-center border-2 border-white/20 pt-[8px] pb-[8px] gap-[0px]" data-id="element-104">
                    <ShoppingCart className="w-5 h-5" data-id="element-105" />
                    <span className="font-bold text-sm uppercase tracking-wider" data-id="element-106">
                      ¡Alguien acaba de comprar!
                    </span>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>}
      </AnimatePresence>
    </>;
}